// Operator of the service, as registered in ЕГРЮЛ. Shown in the site footer and the legal pages.
export const COMPANY = {
  fullName: 'Общество с ограниченной ответственностью «МАРКИТ»',
  shortName: 'ООО «МАРКИТ»',
  inn: '0571023250',
  kpp: '057101001',
  ogrn: '1230500010674',
  address: '367013, Республика Дагестан, г. Махачкала, ул. Ермошкина, д. 93',
  director: 'Идрисов Магомед Магомедович',
  email: 'marqit.ru@mail.ru',
  site: 'https://marqit-analytics.ru',
  bank: {
    account: '40702810301500195896',
    name: 'ООО «Банк Точка»',
    bik: '044525104',
    corrAccount: '30101810745374525104',
  },
};

// Bump when the text of the offer, the policy or the consent changes: the version is stored with
// each person's consent at sign-up.
export const LEGAL_VERSION = '2026-10-03';
